/**
 * @generated SignedSource<<ed6f127b16f11bf7cdc567e9bc47ab99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
import { FragmentRefs } from "relay-runtime";
export type BlockSlot_block$data = {
  readonly blockSeries: {
    readonly color: CustomColor;
    readonly name: string;
  };
  readonly durationMins: number | null | undefined;
  readonly id: string;
  readonly startAt: string;
  readonly " $fragmentType": "BlockSlot_block";
};
export type BlockSlot_block$key = {
  readonly " $data"?: BlockSlot_block$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlockSlot_block">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlockSlot_block",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationMins",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BlockSeries",
      "kind": "LinkedField",
      "name": "blockSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSlotBlock",
  "abstractKey": null
};

(node as any).hash = "716990fc67f2c7c8b30c33cb254cfc0c";

export default node;
